import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  padding: 12.5px 12.5px;
`;

const HeadItem = styled.div`
  flex: 1;
`;
export const PersonTableHead = ({ disabledFields = [] }) => (
  <HeaderContainer>
    <div
      style={{
        padding: '0 27px 0 0',
      }}
    />
    <HeadItem>Name</HeadItem>
    {disabledFields.includes('type') ? null : <HeadItem>Type</HeadItem>}
    <HeadItem>Phone</HeadItem>
    <HeadItem>Country</HeadItem>
  </HeaderContainer>
);



// WEBPACK FOOTER //
// ./components/organisms/people/PersonTableHead.js